var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"stb-button m-btn",style:({
    opacity: _vm.buttonVisible ? 0 : 1,
    pointerEvents: _vm.buttonVisible ? 'none' : 'auto',
  }),attrs:{"title":"Прокрутить в начало сайта"},on:{"click":function($event){return _vm.scrollToTop()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }